<template>
  <div></div>
</template>

<script>
export default {
  name: 'default-layout'
}
</script>
